import React from 'react';
import { css } from '@emotion/css';

import { cn } from '@lyearn/style';

import Box from '../Box';
import { DotProps } from './types';

const dotStyle = (size: number) => css`
  width: ${size / 10}rem;
  height: ${size / 10}rem;
`;

function Dot({
  background = 'bg-icon-secondary',
  className,
  size = 3,
  spacing = 'mx-6',
}: DotProps) {
  return (
    <Box
      className={cn('flex-shrink-0 rounded-full', background, dotStyle(size), className, spacing)}
    />
  );
}

export default Dot;
